import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { get } from 'lodash';
import NumberField from '../../app-main/components/reduxForms/fields/NumberField/NumberField';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Currency from '../../elements-prices/Currency';
import {
  onChangeAddAttendeeRow,
  onChangeAttendeeForm,
  onChangeDeleteAttendeeRow
} from './change/onChangeAttendeeForm';
import { upperCaseFirst } from 'change-case';

const AttendeeFields = ({ fields, currency, dispatch, meta = {} }) => {
  const parseValue = (value) => { return value ? parseInt(value, 10) : null; };

  return (
    <div>
        {
          fields.map((field, index) => {
            return (
              <div>
                <div className="flex top">
                  <div className="flex-basis-50">
                    <div className="flex baseline">
                      {
                        0 === index ?
                          <div className="">{get(fields.get(index), 'min', '')}</div> :
                          <div className="flex-basis-50">
                            <Field
                              parse={parseValue}
                              attendeeIndex={index}
                              className="full-length-input-sm"
                              name={`${field}min`}
                              component={NumberField}
                              placeholder="min"
                              showErrorOnChange
                              onBlur={(e, min) => onChangeAttendeeForm(e, fields, { min }, index, dispatch)}
                            />
                          </div>
                      }
                      <div className="margin-sm-left margin-sm-right">-</div>
                      <div className="flex-basis-50">
                        <div>{get(fields.get(index), 'max', null) || '--'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-basis-50 flex">
                    <div className="attendee-value-container block-xs-left text-right">
                      {
                        0 === index ?
                          <FormattedNumber
                            value={`${fields.get(index).value}`}
                            currency={currency}
                            style="currency"
                            minimumFractionDigits={0}
                            maximumFractionDigits={0}
                          /> :
                          <Field
                            parse={parseValue}
                            attendeeIndex={index}
                            name={`${field}value`}
                            className="AttendeeValueInput full-length-input-sm"
                            component={NumberField}
                            preInputElements={
                              <Currency
                                className="input-group-addon"
                                id="base-rate"
                                currency={currency}
                              />
                            }
                            showErrorOnChange
                            onBlur={(e, value) => onChangeAttendeeForm(e, fields, { value }, index, dispatch)}
                          />
                      }
                    </div>
                  </div>
                  <div className="flex-basis-15">
                    {
                      index === (fields.length - 1) && 0 !== index ?
                        <button onClick={(e) => onChangeDeleteAttendeeRow(e, fields, index, dispatch)} className="btn remove-click-styling delete-button">
                          <img src="/web-hosting/assets/images/trash.svg?v=rb" alt="delete" />
                        </button> : null
                    }
                  </div>
                </div>
                {
                  meta.error && meta.error[index] && <div className="text-danger text-small margin-md-top">{upperCaseFirst(meta.error[index] || '')}</div>
                }
                <hr className="margin-lg-top margin-lg-bottom" />
                {
                  index === (fields.length - 1) && (9 !== index) ?
                    <button
                      onClick={(e) => onChangeAddAttendeeRow(e, fields, dispatch)}
                      className="btn btn-link no-gutter remove-click-styling"
                    >
                      <FormattedMessage id="hosting.attendee_fields.button_text_add_tier" defaultMessage="+ Add tier"/>
                    </button> : null
                }
              </div>
            );
          })
        }
      </div>
  );
};

AttendeeFields.propTypes = {
  fields: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  currency: PropTypes.string,
  meta: PropTypes.object
};

export default AttendeeFields;
